import { type FC } from "react";

interface InfoRowProps {
  icon: FC<{ className?: string }>;
  label: string;
  value: string;
}

export const InfoRow: FC<InfoRowProps> = ({ icon: Icon, label, value }) => (
  <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-6 sm:h-8">
    <div className="flex items-center gap-2 shrink-0">
      <Icon className="h-4 w-4 shrink-0 text-brand" />
      <span className="text-sm text-secondary">{label}</span>
    </div>
    <span className="flex-1 text-sm font-medium min-w-0 pl-6 sm:pl-0">{value}</span>
  </div>
);
